/**
 * Saved-search header pill state. Mirrors `adminPendingStore` exactly so
 * the two pills can coexist cleanly. Updated by:
 *   1. Initial REST fetch on user login (b2c/b2b only).
 *   2. WS "saved_search_match" events carrying `unread_total`.
 *   3. Explicit reset when the user opens the saved-searches tab.
 */
let count = null;
const listeners = new Set();

export function setSavedSearchUnread(n) {
    const next = typeof n === "number" && n >= 0 ? n : 0;
    if (next === count) return;
    count = next;
    listeners.forEach((l) => { try { l(); } catch (_) { /* noop */ } });
}

export function resetSavedSearchUnread() {
    if (count === null) return;
    count = null;
    listeners.forEach((l) => { try { l(); } catch (_) { /* noop */ } });
}

export function getSavedSearchUnread() {
    return count;
}

export function subscribeSavedSearchUnread(listener) {
    listeners.add(listener);
    return () => listeners.delete(listener);
}
